export default function Contact() {
  return (
    <section id="contact" className="bg-[#0a0503] text-white py-20 px-4">

      <div className="max-w-2xl mx-auto text-center">

        {/* HEADING */}
        <h2 className="text-3xl sm:text-4xl font-bold mb-3">
          Get In Touch
        </h2>

        <p className="text-gray-400 mb-10">
          Have questions about our products? We'd love to hear from you!
        </p>

        {/* FORM CARD */}
        <form
  action="https://formsubmit.co/hello@moffeemagic.com"
  method="POST"
  className="bg-[#e7dfd7] rounded-2xl p-6 sm:p-8 text-left shadow-lg"
>

        <input
  type="hidden"
  name="_subject"
  value="New Contact Form Submission - Moffee Magic"
/>

<input
  type="hidden"
  name="_captcha"
  value="false"
/>

          {/* NAME */}
          <div className="mb-5">
            <label className="block text-sm font-medium text-black mb-2">
              Your Name <span className="text-orange-500">*</span>
            </label>
            <input
  type="text"
  name="name"
  required
  placeholder="John Doe"
  className="w-full px-4 py-3 rounded-lg bg-[#d8cec3] text-black outline-none border border-[#cbbfb3] focus:border-[#d68c45] focus:ring-2 focus:ring-[#d68c45] transition"
/>
          </div>

          {/* EMAIL */}
          <div className="mb-5">
            <label className="block text-sm font-medium text-black mb-2">
              Email Address <span className="text-orange-500">*</span>
            </label>
            <input
  type="email"
  name="email"
  required
  placeholder="you@example.com"
  className="w-full px-4 py-3 rounded-lg bg-[#d8cec3] text-black outline-none border border-[#cbbfb3] focus:border-[#d68c45] focus:ring-2 focus:ring-[#d68c45] transition"
/>
          </div>

          {/* MESSAGE */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-black mb-2">
              Message <span className="text-orange-500">*</span>
            </label>
           <textarea
  name="message"
  required
  rows="4"
  placeholder="Tell us what you'd like to know..."
  className="w-full px-4 py-3 rounded-lg bg-[#d8cec3] text-black outline-none resize-none border border-[#cbbfb3] focus:border-[#d68c45] focus:ring-2 focus:ring-[#d68c45] transition duration-200"
></textarea>
          </div>

          <input
  type="hidden"
  name="_next"
  value="https://moffeemagic.com"
/>

          {/* BUTTON */}
            <button
    type="submit"
    className="w-full bg-[#d68c45] hover:bg-[#c57a3a] text-black font-semibold py-3 rounded-lg transition"
  >
    Send Message
  </button>

        </form>

        {/* ALTERNATIVE CONTACT */}
        <div className="mt-10">

          <p className="text-gray-400 mb-4">
            Or reach out via:
          </p>

          <div className="flex flex-col sm:flex-row justify-center gap-4">

            {/* WHATSAPP */}
            <a
              href="https://wa.me/917659977997"
              className="flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 px-6 py-2 rounded-lg"
            >
              WhatsApp
            </a>

            {/* EMAIL */}
            <a
              href="mailto:hello@moffeemagic.com"
              className="flex items-center justify-center gap-2 bg-[#d68c45] hover:bg-[#c57a3a] text-black px-6 py-2 rounded-lg"
            >
              Email
            </a>

          </div>

        </div>

      </div>

    </section>
  );
}